import React from 'react';

// Badges de multi-equipe + "Criado por" / "Editado por" para um Labor Bill compartilhado.
export const BillTeamBadges = ({ bill }) => {
  if (!bill) return null;
  const isMulti = bill.teams && bill.teams.length > 1;
  const createdBy = bill.created_by_team;
  const editedBy = bill.last_edited_by_team;
  if (!isMulti && !createdBy && !editedBy) return null;
  return (
    <div className="flex flex-wrap items-center gap-1 mt-1" data-testid={`bill-team-badges-${bill.id}`}>
      {isMulti && (
        <span className="inline-flex items-center bg-amber-100 border border-amber-300 text-amber-800 rounded px-1.5 py-0.5 text-[10px] font-semibold">
          👥 {bill.teams.join(', ')}
        </span>
      )}
      {createdBy && (
        <span
          data-testid={`bill-created-by-${bill.id}`}
          className="inline-flex items-center bg-emerald-50 border border-emerald-200 text-emerald-700 rounded px-1.5 py-0.5 text-[10px]"
        >
          Criado por {createdBy}
        </span>
      )}
      {editedBy && editedBy !== createdBy && (
        <span
          data-testid={`bill-edited-by-${bill.id}`}
          className="inline-flex items-center bg-blue-50 border border-blue-200 text-blue-700 rounded px-1.5 py-0.5 text-[10px]"
        >
          Editado por {editedBy}
        </span>
      )}
    </div>
  );
};

export default BillTeamBadges;
